import { legendItemStyle, legendStyle, legendItemBoxStyle } from "./style";
import { concessionMenuItems } from "../miningAssets/ConcessionLayer.tsx";

const legendItems = [
  { color: "#F6924E", label: "Coal Plant" },
  { color: "#8FCCA7", label: "Coal Mine" },
  { color: "#2A81BC", label: "Coal Terminal" },
  { color: "#FEE196", label: "Iron Ore Mine" },
  { color: "#9b59b6", label: "Other" },
];

export const MiningAssetsLegend = ({ activeLayers, customLegendStyle = legendStyle }) => {
  return (
    <div style={customLegendStyle}>
      {activeLayers.assetsLayerIsActive && (
        <div>
          <b>Mining Assets</b>
        </div>
      )}

      {activeLayers.assetsLayerIsActive &&
        legendItems.map((item, index) => (
          <div key={index}>
            <span style={legendItemStyle(item.color)}></span>
            {item.label}
          </div>
        ))}

      {activeLayers.concessions && (
        <div>
          <b>Concessions</b>
        </div>
      )}

      {activeLayers.concessions &&
        concessionMenuItems.map((item, index) => (
          <div key={index}>
            <span style={legendItemBoxStyle(item.color)}></span>
            {item.label}
          </div>
        ))}

      {activeLayers.detectedMines && (
        <>
          <div>
            <b>Detected mines</b>
          </div>
          <div key="d0">
            <span style={legendItemBoxStyle("brown")}></span>
            Detected mines
          </div>
        </>
      )}

      {activeLayers.deforestations && (
        <>
          <div>
            <b>Deforestation</b>
          </div>
          <div key="d0">
            <span style={legendItemBoxStyle("orange")}></span>
            Deforestation
          </div>
        </>
      )}

      {activeLayers.indigenous && (
        <>
          <div>
            <b>Indigenous Lands</b>
          </div>
          <div key="d0">
            <span style={legendItemBoxStyle("rgba(165, 42, 42, 0.3)")}></span>
            Indigenous Lands
          </div>
        </>
      )}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          Data processed by CyStellar
        </span>
      </div>
    </div>
  );
};
